import React from 'react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  errorMessage?: string;
  isInvalid?: boolean;
  classNameInput?: string;
}

export const CustomInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
  (
    { className, label, errorMessage, isInvalid, classNameInput, ...props },
    ref,
  ) => {
    return (
      <div className={cn('grid w-full items-center gap-1.5', className)}>
        {label && (
          <Label htmlFor={props.id} className="mb-1 text-right">
            {label}
          </Label>
        )}
        <Input
          name={props.id}
          autoComplete="name"
          className={cn(
            'p-3 text-center transition-colors',
            classNameInput,
            isInvalid && 'border-red-500 focus-visible:ring-red-500',
          )}
          ref={ref}
          {...props}
        />
        {isInvalid && errorMessage && (
          <p className="text-right text-sm text-red-500">{errorMessage}</p>
        )}
      </div>
    );
  },
);

CustomInput.displayName = 'CustomInput';
